import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "@fontsource/poppins"; 
import "@fontsource/poppins/400.css"; 
import "@fontsource/poppins/500.css"; 
import "@fontsource/poppins/600.css"; 
import "@fontsource/poppins/700.css"; 
import "@fontsource/poppins/800.css"; 
import "@fontsource/poppins/900.css"; 
import "@fontsource/lexend"; 
import "@fontsource/lexend/400.css"; 
import "@fontsource/lexend/500.css"; 
import "@fontsource/lexend/600.css"; 
import "@fontsource/lexend/700.css"; 
import "@fontsource/lexend/800.css"; 
import "@fontsource/lexend/900.css"; 
import 'bootstrap/dist/css/bootstrap.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

reportWebVitals();
